(function () {
        document.addEventListener("DOMContentLoaded", function () {
          let canFetch = true;
          let currentlyObserved = null;
          let currentPage = 1; // track current page
          const fetchedPages = new Set(); // track fetched URLs
      
          const loader = document.getElementById("paagination_loader");
          const productList =
            document.querySelector(".grid.product-grid") ||
            document.getElementById("product-grid") ||
            document.querySelector(".ProductList.ProductList--grid.Grid");
      
          const pagination =
            document.querySelector(".pagination-wrapper") ||
            document.querySelector(".pagination");
      
          if (!productList) {
            console.warn("InfiniteScroll: productList not found — aborting.");
            return;
          }
      
          // helper: find last grid item
          function getLastGridItem() {
            const selectors = [
              ".grid__item",
              ".grid_item",
              "li.grid__item",
              "li.grid_item",
              ".Grid__Cell",
              ".grid__cell",
            ];
            for (let sel of selectors) {
              const nodes = productList.querySelectorAll(sel);
              if (nodes.length) return nodes[nodes.length - 1];
            }
            return productList.lastElementChild;
          }
      
          function findNextPageLink() {
            // rel="next"
            const relNext = document.querySelector(
              "a[rel='next'], .pagination a[rel='next']"
            );
            if (relNext) return relNext;
      
            // fallback
            const anchors = pagination
              ? pagination.querySelectorAll("a[href*='page=']")
              : [];
            for (let a of anchors) {
              if (/page=(\d+)/.test(a.href)) {
                const pageNum = parseInt(RegExp.$1);
                if (pageNum > currentPage) return a;
              }
            }
            return null;
          }
      
          const ioOptions = {
            root: null,
            rootMargin: "0px 0px 300px 0px",
            threshold: 0.01,
          };
      
          const observer = new IntersectionObserver(async (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting || !canFetch) continue;
      
              const nextBtn = findNextPageLink();
              if (!nextBtn) {
                console.log("InfiniteScroll: no next button -> stop.");
                observer.disconnect();
                return;
              }
      
              const rawHref =
                nextBtn.getAttribute("href") || nextBtn.dataset.href;
              if (!rawHref) return;
      
              const nextUrl = new URL(rawHref, window.location.origin).toString();
      
              if (fetchedPages.has(nextUrl)) {
                console.log("InfiniteScroll: already fetched", nextUrl);
                return;
              }
      
              try {
                canFetch = false;
                if (loader) loader.style.display = "block";
      
                console.log("InfiniteScroll: fetching", nextUrl);
                const res = await fetch(nextUrl, {
                  headers: { "X-Requested-With": "XMLHttpRequest" },
                });
                if (!res.ok) throw new Error("Fetch failed " + res.status);
      
                const text = await res.text();
                const doc = new DOMParser().parseFromString(text, "text/html");
      
                const newProducts =
                  doc.querySelector(".grid.product-grid") ||
                  doc.getElementById("product-grid") ||
                  doc.querySelector(".ProductList.ProductList--grid.Grid");
      
                if (newProducts) {
                  productList.insertAdjacentHTML("beforeend", newProducts.innerHTML);
                  console.log("InfiniteScroll: appended new items");
                  if (typeof window.initAll === "function") {
                    window.initAll(productList);
                    console.log("InfiniteScroll: re-initialized swiper & swatches");
                  }
                } else {
                  console.warn("InfiniteScroll: no products container found.");
                  observer.disconnect();
                  return;
                }
      
                // update pagination
                const newPagination =
                  doc.querySelector(".pagination-wrapper") ||
                  doc.querySelector(".pagination");
                if (newPagination && pagination) {
                  pagination.innerHTML = newPagination.innerHTML;
                }
      
                // mark page fetched
                fetchedPages.add(nextUrl);
                const match = nextUrl.match(/page=(\d+)/);
                if (match) currentPage = parseInt(match[1]);
      
                if (loader) loader.style.display = "none";
                canFetch = true;
      
                // update observer target
                if (currentlyObserved) observer.unobserve(currentlyObserved);
                const newLast = getLastGridItem();
                if (newLast) {
                  currentlyObserved = newLast;
                  observer.observe(newLast);
                } else {
                  observer.disconnect();
                }
              } catch (err) {
                console.error("InfiniteScroll fetch error:", err);
                if (loader) loader.style.display = "none";
                canFetch = true;
              }
            }
          }, ioOptions);
      
          function startObserving() {
            const last = getLastGridItem();
            if (last) {
              currentlyObserved = last;
              observer.observe(last);
              return true;
            }
            return false;
          }
      
          if (!startObserving()) {
            const mo = new MutationObserver((mutations, mObserver) => {
              if (startObserving()) mObserver.disconnect();
            });
            mo.observe(productList, { childList: true, subtree: true });
          }
      
          window.addEventListener("beforeunload", () => observer.disconnect());
        });
      })();
     